import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Spinner from './Spinner';

const UsersEdit: React.FC = () => {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    // pegar id da URL
    const parts = window.location.pathname.split('/');
    const id = parts[parts.length - 1];
    const base = process.env.REACT_APP_API_URL || '';
    const url = base ? `${base.replace(/\/$/, '')}/api/users/${id}` : `/api/users/${id}`;
    axios.get(url, { withCredentials: true })
      .then(res => setUser(res.data))
      .catch(err => setError(err?.response?.data?.message || err.message || 'Erro'))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (k: string, v: any) => setUser((s: any) => ({ ...s, [k]: v }));

  const handleSave = async () => {
    if (!user) return;
    setSaving(true);
    try {
      const base = process.env.REACT_APP_API_URL || '';
      const url = base ? `${base.replace(/\/$/, '')}/api/users/${user._id || user.username}` : `/api/users/${user._id || user.username}`;
      await axios.patch(url, user, { withCredentials: true });
      alert('Salvo com sucesso');
      window.close();
    } catch (err: any) {
      alert(err?.response?.data?.message || err.message || 'Erro ao salvar');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Spinner />;
  if (error) return <div className="container py-4"><div className="alert alert-danger">{error}</div></div>;
  if (!user) return <div className="container py-4">Usuário não encontrado</div>;

  return (
    <div className="container py-4">
      <h3>Editar usuário: {user.username}</h3>
      <div className="mb-3">
        <label className="form-label">Nome</label>
        <input className="form-control" value={user.name || ''} onChange={e => handleChange('name', e.target.value)} />
      </div>
      <div className="mb-3">
        <label className="form-label">E-mail</label>
        <input className="form-control" value={user.email || ''} onChange={e => handleChange('email', e.target.value)} />
      </div>
      <div className="mb-3">
        <label className="form-label">Perfil</label>
        <input className="form-control" value={user.profile || ''} onChange={e => handleChange('profile', e.target.value)} />
      </div>
      <div className="mb-3">
        <label className="form-label">Nova senha (deixe em branco para não alterar)</label>
        <input className="form-control" type="password" onChange={e => handleChange('password', e.target.value)} />
      </div>
      <div className="d-flex gap-2">
        <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
        <button className="btn btn-secondary" onClick={() => window.close()}>Fechar</button>
      </div>
    </div>
  );
};

export default UsersEdit;
